import KarteInterface from "../../../interfaces/KarteInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import Icon from "../../atoms/Icon/index";
import SquareImageList from "../../atoms/SquareImageList/index";
import { FormattedText } from "../../general/FormattedText";
import KarteFileAttachmentList from "../KarteFileAttachmentList";
import KarteItemFooter from "./KarteItemFooter/index";
import KarteItemHeader from "./KarteItemHeader";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  karte: KarteInterface;
  canPin?: boolean;
}

const renderCommentIcon = (props: Props) => {
  const { karte } = props;

  if (karte.comments.length === 0) {
    return (
      <span className={styles.commentIcon}>
        <Icon name="icon-action-comment-default" className={styles.icon} />
        コメント
      </span>
    );
  } else {
    return (
      <span className={`${styles.commentIcon} ${styles.active}`}>
        <Icon
          name="icon-action-comment-selected"
          className={`${styles.icon}`}
        />
        {karte.comments.length}
      </span>
    );
  }
};

const KarteItem = (props: Props) => {
  const { section, karte, canPin } = props;

  return (
    <div className={styles.root} role="listitem" data-testid="karte-listitem">
      <div className={styles.main}>
        <KarteItemHeader sectionId={section.id} karte={karte} canPin={canPin} />
        <p className={styles.comment}>
          <FormattedText>{karte.comment}</FormattedText>
        </p>
        <SquareImageList
          imageUrls={karte.imageAttachments.map((image) => image.presignedUrl)}
          keys={karte.imageAttachments.map(
            (image) => `KarteItem-SquareImageList-${image.id}`,
          )}
        />
        <KarteFileAttachmentList
          fileAttachments={karte.fileAttachments}
          keys={karte.fileAttachments.map(
            (attachment) =>
              `KarteItem-KarteFileAttachmentList-${attachment.id}`,
          )}
        />
        {renderCommentIcon(props)}
      </div>
      <KarteItemFooter
        karte={karte}
        studentId={karte.student.id}
        sectionId={section.id}
      />
    </div>
  );
};

export default KarteItem;
